import { CONFIGURATION_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: CONFIGURATION_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkConfiguration'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/configuration/index.js